// extracted by mini-css-extract-plugin
export default {"menuLoader":"select_menuLoader__lG+eq","menuLoaderSpinner":"select_menuLoaderSpinner__FDSPq","menuSpinnerAnim":"select_menuSpinnerAnim__tPAZJ"};